<template lang="html">
  <div class="box">
    <span class="box-header">新用户建立 2/2</span>
    <div v-if="getCheckedhobbys.length" class="select-box">
      <div :class="{ item: true, active: item[1].checked }" v-for="item in getCheckedhobbys" :key="item[0]">
        <span>{{item[1].name}}</span>
        <img @click="removeHonny(item[0])" src="../../assets/images/close.svg" alt="">
      </div>
    </div>
    <template v-else>
      <h5 class="header">你有哪些最新的爱好呢？请从以下标签选择吧</h5>
    </template>
    <div class="honny-box">
      <span v-for="item in Object.entries(showHobbys)" @click="addHonny(item[0])" :class="{ item: true, active: item[1].checked }" :key="item[0]">{{item[1].name}}</span>
      <div class="honny-box-footer" @click="randomPage">
        <img src="../../assets/images/reload.svg" alt="">
        <span>换一批</span>
      </div>
    </div>
    <div class="login" @click="updateHobby" :style="{background: Object.keys(getCheckedhobbys).length ? 'rgba(95, 184, 120, 1)' : 'rgba(229,229,234,1)'}">
      <img src="../../assets/images/long-right.svg" alt="">
    </div>
    <Tip v-if="model" @closeModel="closeModel" label="最多选取5个" />
  </div>
</template>
<script>
import { get, put } from '../../utils/request'
import Tip from '../../components/message.vue'
import { set, get as getItem } from '../../utils/token'
export default {
  components: {
    Tip
  },
  data () {
    return {
      hobbys: {},
      model: false,
      count: 0,
      page: 1,
      size: 12
    }
  },
  mounted () {
    this.getAllHobbys()
  },
  methods: {
    updateHobby () {
      const values = Object.values(this.getCheckedhobbys)
      const hobbyList = values.map(item => Number.parseInt(item[0]))
      const promise = put({
        url: '/user/personalHobbys',
        data: {
          hobbyList: hobbyList,
          userId: getItem('user').id
        }
      })
      promise.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          const user = getItem('user')
          Object.assign(user, {
            hobbys: hobbyList
          })
          set('user', user)
          this.$router.push('/exerland')
        }
      })
    },
    closeModel () {
      this.model = false
    },
    removeHonny (index) {
      this.hobbys[index].checked = false
    },
    addHonny (index) {
      if (this.getCheckedhobbys.length < 5) {
        this.hobbys[index].checked = true
      } else {
        this.model = true
      }
    },
    getAllHobbys () {
      const promise = get({
        url: '/user/hobbys'
      })
      promise.then(res => {
        const { data, status } = res
        if (Object.is(status, 200)) {
          const hobbys = (getItem('user') && getItem('user').hobbys) ? getItem('user').hobbys : []
          const _data = data.map(item => {
            item.checked = false
            hobbys.forEach(hobby => {
              if (Object.is(hobby, item.nid)) {
                item.checked = true
              }
            })
            return [item.nid, item]
          })
          this.count = _data.length
          const map = Object.fromEntries(_data)
          this.hobbys = map
        }
      })
    },
    randomPage () {
      const pages = Math.ceil(this.count / this.size)
      const page = Math.ceil(Math.random() * pages)
      this.page = page
    }
  },
  computed: {
    getCheckedhobbys () {
      return Object.entries(this.hobbys).filter(item => item[1].checked)
    },
    showHobbys () {
      const page = this.page
      const size = this.size
      const count = this.count
      const entries = Object.entries(this.hobbys)
      let array = []
      if (((page - 1) * size < count) && (page * size > count)) {
        array = entries.slice((page - 1) * this.size)
      } else {
        array = entries.slice((page - 1) * this.size, page * this.size)
      }
      return Object.fromEntries(array)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
body {
  background-color: #fff;
}
.box{
  width: 336px;
  height: 100vh;
  background: #fff;
  margin: 76px auto 37px auto;
  .box-header {
    font-size:24px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(1,170,237,1);
    line-height:33px;
  }
  .select-box {
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
  }
  .header {
    font-size:20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(204,204,204,1);
    line-height:28px;
    padding-top: 19px;
    padding-bottom: 65px;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    margin-bottom: 16px;
  }
  .honny-box {
    width: 100%;
    .honny-box-footer {
      text-align: center;
      margin-top: 16px;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 8px;
      }
      span {
        font-size:13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(95,184,120,1);
        line-height:18px;
      }
    }
  }
  .item {
    margin: 8px;
    display:inline-block;
    box-sizing: border-box;
    width:68px;
    height:44px;
    background:rgba(245,245,245,1);
    border-radius:22px;
    line-height: 44px;
    text-align: center;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    cursor: pointer;
    &.active{
      background: rgba(1, 170, 237, 1);
      color: rgba(255, 255, 255, 1);
    }
    img {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-left: 6px;
    }
  }
  .login {
    width: 88px;
    height:88px;
    border-radius: 50%;
    background:rgba(229,229,234,1);
    margin: 52px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 29.86px;
      height: 29.86px
    }
  }
}
</style>
